<template>
  <div class="wrap1">
    <h2 class="common-title">
      <span>{{ title }}</span>
      <div v-if="but">
        <el-button size="small" v-if="but.history" @click="handleHistory(but.history)">{{
          but.history.label
        }}</el-button>
        <el-button size="small" v-if="but.timing && authority.edit" @click="handleTiming(but.timing)" type="primary">{{
          but.timing.label
        }}</el-button>
      </div>
    </h2>
    <div class="wrap1-content">
      <div v-for="(item, index) in listData" :key="item.title">
        <h2 v-if="item.title">{{ item.title }}</h2>
        <ul>
          <li
            v-for="(cItem, cIndex) in item.list"
            :key="cItem.name"
            @click="handleItem({ cItem, cIndex, item, index })"
          >
            <img :src="cItem.icon" alt="" />
            <div class="wrap1-content-right">
              <h2>{{ cItem.name }}</h2>
              <p>{{ cItem.txt }}</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    listData: {
      type: Array
    },
    but: {
      type: Object
    },
    title: {
      type: String
    },
    authority: {
      type: Object
    }
  },
  data() {
    return {}
  },
  methods: {
    handleItem(item) {
      this.$emit('handleItem', item)
    },
    handleHistory(item) {
      this.$router.push({
        path: item.path
      })
    },
    handleTiming(item) {
      this.$router.push({
        path: item.path
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.wrap1 {
  .common-title {
    display: flex;
    span {
      flex: 1;
    }
  }
  &-content {
    background: #fff;
    padding: 24px 24px 0;
    h2 {
      font-weight: 500;
      font-size: 14px;
      color: #262626;
      line-height: 22px;
      margin-bottom: 12px;
    }
    ul {
      display: flex;
      flex-wrap: wrap;
      li {
        width: 320px;
        height: 100px;
        padding: 16px;
        box-sizing: border-box;
        border: 1px solid #d9d9d9;
        border-radius: 4px;
        margin-right: 24px;
        margin-bottom: 32px;
        display: flex;
        img {
          width: 24px;
          height: 24px;
          margin-right: 8px;
        }
        h2 {
          font-size: 16px;
          line-height: 24px;
          margin-bottom: 8px;
        }
        p {
          height: 36px;
          font-size: 12px;
          color: #8c8c8c;
          line-height: 18px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        &:hover {
          cursor: pointer;
          box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.12);
          border-radius: 4px;
          h2 {
            color: #5D51DA;
          }
        }
        .wrap1-content-right {
          flex: 1;
        }
      }
    }
  }
}
h2 {
  margin: 0;
}
</style>
